module.exports = __webpack_public_path__ + "img/virtual-assistant-lakeshore-splash.ae13680a.jpg";